import React, { useEffect, useRef, useState, useCallback } from "react";
import { useTable, usePagination, useSortBy } from "react-table";

import { Table, Row, Col, Alert, Pagination } from "react-bootstrap";

import ListButton from "./ListButton";
import { debounce } from 'lodash';
import { handleCalculateTop, handleStickyHeaderObserver, stickyHeaderResizeListener, syncHeaderStyles } from "../../../../../utils/stickyHeaderHelper";

const Lists = ({ columns, rawData, creditNoteApi, status, linkReroute, navigationStickyComponent, filterStickyComponent, scrollContainerRef}) => {

    const [currentColumns, setCurrentColumns] = useState([]);
    useEffect(() => {
        setCurrentColumns((status?.toLowerCase() === 'finance-director') ? columns : columns.filter(column => column.accessor !== "refund_status"));
    }, [status])

    const { meta, links, data } = rawData;
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        state: {
            pageSize,
            canNextPage,
            canPreviousPage,
            totalPage,
            currentPage,
            firstPage,
            lastPage,
        },
    } = useTable(
        {
            columns: currentColumns,
            data,
            initialState: {
                pageIndex: 0,
                pageSize: meta?.per_page,
                canNextPage: links?.next !== null ? true : false,
                canPreviousPage: links?.prev !== null ? true : false,
                totalPage: meta?.last_page,
                currentPage: meta?.current_page,
                firstPage: meta?.first,
                lastPage: meta?.last_page,
            },
        },
        useSortBy,
        usePagination
    );
    const gotoPage = (page) => {
        creditNoteApi({
            page,
        });
    };
    
    const tableHeaderRef = useRef(null);
    const [headerStyles, setHeaderStyles] = useState([]);
    const [isStickyHeaderVisible, setIsStickyHeaderVisible] = useState(false); // Flag to track if sticky class is applied
    const [styleTop, setStyleTop] = useState(0);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            handleCalculateTop(filterStickyComponent, setStyleTop, status = 'summary');
        });
    }, [])

    useEffect(() => {
        stickyHeaderResizeListener(setHeaderStyles, tableHeaderRef, navigationStickyComponent, filterStickyComponent, setStyleTop, status == 'summary');
    }, [data]);

    useEffect(() => {
        let currentRootMargin = isStickyHeaderVisible ? "-325px 0px 0px 0px" : "-250px 0px 0px 0px";
        if (status == 'summary') {
            currentRootMargin = isStickyHeaderVisible ? "-425px 0px 0px 0px" : "-350px 0px 0px 0px";
        }
        handleStickyHeaderObserver(isStickyHeaderVisible, tableHeaderRef,  currentRootMargin, setIsStickyHeaderVisible, setHeaderStyles);
    }, [isStickyHeaderVisible]);


    return (
        <>
            {data.length > 0 && (
                <Row ref={scrollContainerRef}>
                    <div className={`${status === 'summary' ? 'fixed-header-navigation-cn' : ''}`} style={{ top: styleTop }}>
                        {totalPage > 1 && (
                        <Row  ref={navigationStickyComponent}>
                            <Col md="6">
                                <span className="mx-2">
                                    Page {""}
                                    <strong>
                                        {currentPage} of {totalPage}
                                    </strong>
                                </span>
                            </Col>
                            <Col md="6">
                                <Pagination className="float-end">
                                    <Pagination.First
                                        onClick={() => gotoPage(firstPage)}
                                        disabled={!canPreviousPage}
                                    />
                                    <Pagination.Prev
                                        onClick={(i) =>
                                            gotoPage(currentPage - 1)
                                        }
                                        disabled={!canPreviousPage}
                                    />
                                    <Pagination.Next
                                        onClick={() =>
                                            gotoPage(currentPage + 1)
                                        }
                                        disabled={!canNextPage}
                                    />
                                    <Pagination.Last
                                        onClick={() => gotoPage(lastPage)}
                                        disabled={!canNextPage}
                                    />
                                </Pagination>
                            </Col>
                        </Row>
                        )}
                        {isStickyHeaderVisible && (status == 'summary') && (
                            <div className="mx-2">
                                {/* Sticky Header Container */}
                                <Table responsive striped bordered {...getTableProps()}>
                                    <thead>
                                        {headerStyles?.map((style, index) => (
                                            <tr style={style} key={index}>
                                                {style.headerChildren?.map((tdStyle, tdIndex) => (
                                                    <th key={tdIndex} style={tdStyle}>
                                                        {headerGroups[0]?.headers[tdIndex]?.render("Header")}
                                                    </th>
                                                ))}
                                            </tr>
                                        ))}
                                    </thead>
                                </Table>
                            </div>
                        )}
                    </div>
                    <Table responsive striped bordered {...getTableProps()}>

                        {/* <thead className="fixed-table-header" style={{top: styleTop}} ref={tableHeaderRef}> */}
                        <thead className="fixed-table-header" ref={tableHeaderRef}>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th
                                            {...column.getHeaderProps(
                                                column.getSortByToggleProps()
                                            )}
                                        >
                                            {column.render("Header")}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, i) => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map((cell, index, row) => {
                                            if (index === 0) {
                                                return (
                                                    <td key={index}>
                                                        {currentPage > 1
                                                            ? (currentPage -
                                                                  1) *
                                                                  pageSize +
                                                              i +
                                                              1
                                                            : i + 1}
                                                    </td>
                                                );
                                            }
                                            if (index + 1 === row.length) {
                                                return (
                                                    <td key={index}>
                                                        <ListButton
                                                            cell={cell}
                                                            currentPage={
                                                                currentPage
                                                            }
                                                            status={status}
                                                            linkReroute={linkReroute}
                                                            creditNoteApi={creditNoteApi}
                                                        />
                                                    </td>
                                                );
                                            }
                                            return (
                                                <td {...cell.getCellProps()}>
                                                    {cell.render("Cell")}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                    {totalPage > 1 && (
                        <Row>
                            <Col md="6">
                                <span className="mx-2">
                                    Page {""}
                                    <strong>
                                        {currentPage} of {totalPage}
                                    </strong>
                                </span>
                            </Col>
                            <Col md="6">
                                <Pagination className="float-end">
                                    <Pagination.First
                                        onClick={() => gotoPage(firstPage)}
                                        disabled={!canPreviousPage}
                                    />
                                    <Pagination.Prev
                                        onClick={(i) =>
                                            gotoPage(currentPage - 1)
                                        }
                                        disabled={!canPreviousPage}
                                    />
                                    <Pagination.Next
                                        onClick={() =>
                                            gotoPage(currentPage + 1)
                                        }
                                        disabled={!canNextPage}
                                    />
                                    <Pagination.Last
                                        onClick={() => gotoPage(lastPage)}
                                        disabled={!canNextPage}
                                    />
                                </Pagination>
                            </Col>
                        </Row>
                    )}
                </Row>
            )}
            {data.length === 0 && (
                <Alert variant="warning">
                    <div className="alert-message">No credit notes</div>
                </Alert>
            )}
            {/* <DeleteModal
                modalInfo={modalInfo}
                setModalInfo={setModalInfo}
                api={deleteCompany}
            /> */}
        </>
    );
};

export { Lists };
